import Repository from '@/libs/axios'

const paymentGatewayResource = '/admin/payment-gateways'

const defaultPagination = 20

export default {
  getCheckoutData(id, name) {
    return Repository.get(`/checkout-data/${id}/${name}`)
  },
  getQR(id, name) {
    return Repository.get(`/checkout/${name}/qr/${id}`)
  },
  sendNotifications(orderId) {
    return Repository.post(`/payment/notify?order_id=${orderId}`)
  },
  paymentGateways(pageNumber = 1, filterQuery, pagination = defaultPagination) {
    return Repository.get(`${paymentGatewayResource}?page=${pageNumber}&paginate=${pagination}&${filterQuery}`)
  },
  paymentGatewaysNoPagination(filterQuery) {
    return Repository.get(`${paymentGatewayResource}?${filterQuery}&noPagination`)
  },
  addPaymentGateway(payload) {
    return Repository.post(`${paymentGatewayResource}/add-gateway`, payload)
  },
  getPaymentGatewayByID(id) {
    return Repository.get(`${paymentGatewayResource}/${id}`)
  },
  updatePaymentGateway(id, payload) {
    return Repository.put(`${paymentGatewayResource}/${id}/update`, payload)
  },
  updatePaymentGatewayStatus(id, payload) {
    return Repository.put(`${paymentGatewayResource}/status/${id}/update`, payload)
  },
}
